/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Ivetta Tkachenko <ivetta.tkachenko@opensoftdev.ru>
 */

define(['backbone', 'assets/js/modules/widgets/mailingService/mailingServiceWidgetModel'], function(backbone, MailingServiceWidgetModel) {
    return backbone.Model.extend({
        defaults: {
            /** @var {ProductGroup} productGroup */
            productGroup: null,
            designGalleryName: null,
            defaultProduct: null,
            defaultSides: null,
            defaultQuantity: null,
            defaultSkuId: null,

            product: null,
            products: [],
            pricingCalcItem: null,
            pricingCalcItems: [],
            /** @var {PricingCalcModel} pricingCalc */
            pricingCalc: null,

            mailingService: new MailingServiceWidgetModel(),

            total: 0,

            currency: null,

            template: null,
            gallery: null,

            startFileWidgetModel: null,

            showDvsDesigner: false,
            showGallery: false,
            showProductTabs: true,
            showUploadInfo: true,
            handleBannerClicks: true,
            eventAgent: {}
        },

        initialize: function(options) {
            this.set('products', new backbone.Collection());
            this.set('pricingCalcItems', new backbone.Collection());
        },

        getSideCount: function() {
            if (!this.get('pricingCalcItem')) {
                return null;
            }

            return this.get('pricingCalcItem')
                .getSelectedSide()
                .get('sides');
        },

        /**
         * Returns if any of the products have samples
         *
         * @returns {boolean}
         */
        hasProductWithSamples: function() {
            return this.get('products').some(function(product) {
                return product.hasSamples();
            });
        }
    });
});
